"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * External Dependencies
 */
var jquery_1 = __importDefault(require("jquery"));
var micromodal_1 = __importDefault(require("micromodal"));
var header_1 = __importDefault(require("./components/header"));
var calltoaction_1 = __importDefault(require("./components/calltoaction"));
var groupedcontent_1 = __importDefault(require("./components/groupedcontent"));
var slider_1 = __importDefault(require("./components/slider"));
var landingpage_slider_1 = __importDefault(require("./components/landingpage_slider"));
var map_1 = __importDefault(require("./components/map"));
var findanadvisor_1 = __importDefault(require("./components/findanadvisor"));
var dropdown_1 = __importDefault(require("./components/dropdown"));
var suggestedsearch_1 = __importDefault(require("./components/suggestedsearch"));
var simple_filtering_1 = __importDefault(require("./components/filtering/simple-filtering"));
var accordion_1 = __importDefault(require("./components/accordion"));
var animateCountableNumbers_1 = __importDefault(require("./components/animateCountableNumbers"));
var formRecipientHandler_1 = __importDefault(require("./components/formRecipientHandler"));
document.addEventListener('DOMContentLoaded', function () {
    micromodal_1.default.init({
        awaitCloseAnimation: true,
        disableScroll: true,
        disableFocus: true
    });
    //Leaving website
    function openModal() {
        jquery_1.default(document).on('touchmove', function (ev) {
            if (jquery_1.default(ev.target).closest('.locked').length) {
                ev.preventDefault();
            }
            if (jquery_1.default(ev.target).closest('.bumperlocked').length) {
                ev.preventDefault();
            }
            jquery_1.default('.News-modal-wrapper').bind('touchmove', function (e) {
                e.stopPropagation();
            });
            jquery_1.default('.FilterModal').bind('touchmove', function (e) {
                e.stopPropagation();
            });
            jquery_1.default('.FilterModal-container').bind('touchmove', function (e) {
                e.stopPropagation();
            });
        });
    }
    function closeModal() {
        jquery_1.default('body').unbind('touchmove');
    }
    jquery_1.default("a[target='new'], a[target='_blank']").on('click touch', function (event) {
        if (!jquery_1.default(this).hasClass('Bumper-enter')) {
            event.preventDefault();
            jquery_1.default('.BumperLink').fadeIn();
            jquery_1.default('html, body').addClass('bumperlocked');
            openModal();
            var $link = jquery_1.default(this).attr('href');
            jquery_1.default('.Bumper-enter').attr('href', $link);
            jquery_1.default('.Bumper-enter').text('Visit ' + $link);
        }
    });
    jquery_1.default('.Bumper-exit').on('click touch', function (event) {
        event.preventDefault();
        jquery_1.default('.Bumper').fadeOut();
        jquery_1.default('html, body').removeClass('bumperlocked');
        closeModal();
    });
    jquery_1.default('.Bumper-background').on('click touch', function (event) {
        event.preventDefault();
        jquery_1.default('.Bumper').fadeOut();
        jquery_1.default('html, body').removeClass('bumperlocked');
        closeModal();
    });
    //
    function scrollBackTop() {
        if (jquery_1.default(window).scrollTop() > 500) {
            jquery_1.default(".backToTopBtn").addClass("active");
        }
        else {
            jquery_1.default(".backToTopBtn").removeClass("active");
        }
    }
    jquery_1.default(function () {
        scrollBackTop();
        jquery_1.default(window).on("scroll", scrollBackTop);
        jquery_1.default(".backToTopBtn").click(function () {
            jquery_1.default("html, body").animate({ scrollTop: 0 }, 1);
            return false;
        });
    });
    header_1.default();
    calltoaction_1.default();
    groupedcontent_1.default();
    slider_1.default();
    landingpage_slider_1.default();
    map_1.default();
    findanadvisor_1.default();
    dropdown_1.default();
    accordion_1.default();
    animateCountableNumbers_1.default();
    suggestedsearch_1.default();
    simple_filtering_1.default();
    formRecipientHandler_1.default();
});
